import React, {
  createContext,
  CSSProperties,
  ForwardRefExoticComponent,
  ReactNode,
  RefAttributes,
  useContext,
} from 'react'

import { ClickEvent } from '@web/types'
import UIClickable from '@web/ui/components/Clickable/UIClickable'

export interface ClickableProps {
  children: React.ReactNode
  role?: string
  className?: string
  disabled?: boolean
  onClick?: (e: ClickEvent) => void
  href?: string
  replace?: boolean
  newWindow?: boolean
  nClickCode?: string
  nClickCid?: string | number
  nClickRank?: string | number
  nClickPlaceId?: string
  nClickReviewId?: string
  nClickVisitId?: string
  nClickBusinessId?: string
  contentType?: string
  stopPropagation?: boolean
  style?: CSSProperties
}

const ClickableContext = createContext(UIClickable)

export function ClickableContextProvider({
  clickable,
  children,
}: {
  clickable: ForwardRefExoticComponent<ClickableProps & RefAttributes<HTMLButtonElement>>
  children: ReactNode
}) {
  return <ClickableContext.Provider value={clickable}>{children}</ClickableContext.Provider>
}

export function useClickableContext() {
  return useContext(ClickableContext)
}
